<template>
  <div style="width: 100%;height: 100%; ">
    <!-- 首页地图与图表页面 -->
    <div class="lefcen">
      <lefttopcharts :deviceOnline="line.deviceOnline" :deviceOffline="line.deviceOffline"></lefttopcharts>
      <rightchartstop :list="list1"></rightchartstop>
      <div class="Map_Select">
        <el-select v-model="MapSelectValue" size="mini" style="width:100%" @change="selectChange">
          <el-option v-for="item in MapSelect" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div id="map"></div>
    <p class="MapTime">
      {{ $t("lang.particulars.ProcessDate") }}:{{ UpdateTime }}
    </p>
    <!-- <div style="width: 100%;height: 100%">
      <dashboard-bmmap v-if="this.Map==='zh-CN'" :allDevice="MapSelectValue"></dashboard-bmmap>
      <googlemap v-if="this.Map==='en-US'"></googlemap>
    </div> -->
    <div class="rigcen"></div>
  </div>
</template>
<script>
import {
  getUserGroup,
  getDeviceAddressList,
  getDeviceInformation,
  getMarkerInfo,
} from "@/api/login";
import {
  setgroup,
  setclient_user_id,
  GetLan,
  SetMapType,
  GetMapType,
} from "@/localStorage/localStorage";
import DashboardBmmap from "./components/bmmap";
import lefttopcharts from "./components/lefttopcharts";
import leftbottomcharts from "./components/leftbottomcharts";
import rightchartstop from "./components/rightchartstop";
import googlemap from "./components/googlemap";
import L from "leaflet";
import { coordtransform } from "@/utils/mapUtils";
import {
  PruneCluster,
  PruneClusterForLeaflet,
} from "exports-loader?PruneCluster,PruneClusterForLeaflet!prunecluster/dist/PruneCluster.js";

export default {
  data() {
    return {
      //图表//
      list1: [
        { value: 0, name: this.$t("lang.dashboard.chieffinancialofficer") },
        { value: 0, name: this.$t("lang.dashboard.Router") },
        { value: 0, name: this.$t("lang.dashboard.PrintStream") },
        { value: 0, name: this.$t("lang.dashboard.Serial") },
        { value: 0, name: this.$t("lang.dashboard.Other") },
      ],
      line: {
        deviceOnline: null,
        deviceOffline: null,
      },
      //地图下拉选项
      MapSelect: [
        { value: 0, label: this.$t("lang.dashboard.OfflineDevice") },
        { value: 1, label: this.$t("lang.dashboard.OnlineDevice") },
        { value: 2, label: this.$t("lang.dashboard.AllDevices") },
      ],
      //地图下拉选项选中内容
      MapSelectValue: 2,
      DeviceTime: null,
      offset: 1,
      //默认加载10W台设备，如果超过这个数量页面会造成卡顿
      limit: 100000,
      //定时刷新地图， 60s
      MapTime: null,
      //更新时间
      UpdateTime: null,
      center: L.latLng(50.5, 30.51), // 地图中心
      markers: null,
      map: null,
      mapLaguage: "zh_cn",
      // coordtransform
    };
  },
  mounted() {
    // 初始化地图
    this.initMap();
    //获取总设备数数据
    this.GetDeviceList();
    this.MapTime = setInterval(() => {
      // this.map.remove()
      this.setMarkers();
    }, 60000);
  },
  components: {
    DashboardBmmap,
    lefttopcharts,
    leftbottomcharts,
    rightchartstop,
    googlemap,
  },
  methods: {
    //获取设备数量与设备在线离线率
    GetDeviceList() {
      clearInterval(this.DeviceTime);
      getDeviceInformation().then((res) => {
        if (res.data.code === 0) {
          this.list1[0].value = res.data.data.deviceZP;
          this.list1[1].value = res.data.data.deviceZRZS;
          this.list1[2].value = res.data.data.devicePS;
          this.list1[3].value = res.data.data.deviceSS;
          this.list1[4].value = res.data.data.deviceOther;
          this.line.deviceOnline = res.data.data.deviceOnline;
          this.line.deviceOffline = res.data.data.deviceOffline;
          this.DeviceTime = setInterval(() => {
            this.GetDeviceList();
          }, 10000);
        }
      });
    },
    initMap() {
      this.map = null;
      let laguage = GetLan();
      if (laguage === "zh-CN" || laguage == null) {
        this.mapLaguage = "zh_cn";
      } else {
        this.mapLaguage = "en";
      }
      // 高德地图图层
      let tiles = L.tileLayer(
        `http://webrd0{s}.is.autonavi.com/appmaptile?lang=${this.mapLaguage}&size=1&scale=1&style=8&x={x}&y={y}&z={z}`,
        {
          attribution: "&copy; 高德地图",
          maxZoom: 15,
          minZoom: 3,
          subdomains: "1234",
        }
      );
      // google地图
      let gooleTiles = L.tileLayer(
        `http://www.google.cn/maps/vt?lyrs=m@189&hl=${this.mapLaguage}&gl=cn&x={x}&y={y}&z={z}`,
        {
          attribution: "&copy; 谷歌地图",
          maxZoom: 15,
          minZoom: 3,
          subdomains: "1234",
        }
      );
      // 添加openstreetmap图块层
      let openTiles = L.tileLayer(
        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          maxZoom: 18,
          minZoom: 3,
          // openstreetmap归因
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }
      );
      let center = L.latLng(35.5, 108); // 中心点经纬度
      var baseLayers = {
        // 高德地图: tiles,
        Google地图: gooleTiles,
        openStreetMap: openTiles,
      };
      if (GetLan() == null || GetLan() == "zh-CN") {
        baseLayers = {
          // 高德地图: tiles,
          Google地图: gooleTiles,
          openStreetMap: openTiles,
        };
      } else {
        baseLayers = {
          // Amap: tiles,
          "Google Map": gooleTiles,
          openStreetMap: openTiles,
        };
      }
      let mapType = GetMapType();
      let customerTiles = tiles;
      if (mapType === "Google地图" || mapType === "Google Map") {
        customerTiles = gooleTiles;
      } else if (mapType === "openStreetMap") {
        customerTiles = openTiles;
      } else {
        customerTiles = openTiles;
      }
      this.map = L.map("map", {
        center: center,
        zoom: 4, // 缩放级别
        layers: [customerTiles], //添加图层到地图上
        zoomControl: false,
        worldCopyJump: true, //不允许一直向一个方向拖动，这样新生成的没有makers
      });
      L.control.layers(baseLayers, null, { collapsed: false }).addTo(this.map);
      // 监听地图的切换
      this.map.on("baselayerchange", (e) => {
        this.map.removeLayer(this.markers);
        this.setMarkers();
        SetMapType(e.name);
      });
      this.setMarkers();
    },
    // 设置聚合点
    setMarkers() {
      // 从后端获取设备数据
      getDeviceAddressList(this.offset, this.limit, this.MapSelectValue).then(
        (res) => {
          //当前更新时间
          let date = new Date();
          this.UpdateTime = date.toLocaleString(
            this.$i18n.locale == "zh-CN" ? "zh" : "en"
          );
          let mapType = GetMapType();
          if (this.markers) {
            this.markers.RemoveMarkers();
          } else {
            this.markers = new PruneClusterForLeaflet();
          }
          let list = [];
          res.data.data.list.forEach((element) => {
            if (
              element[Object.keys(element)[0]][0] != null &&
              element[Object.keys(element)[0]][1] != null
            ) {
              element[Object.keys(element)[0]].push(Object.keys(element)[0]);
              list.push(element[Object.keys(element)[0]]);
            } else {
              element[Object.keys(element)[0]][0] = "113.866716";
              element[Object.keys(element)[0]][1] = "22.568048";
              element[Object.keys(element)[0]].push(Object.keys(element)[0]);
              list.push(element[Object.keys(element)[0]]);
            }
          });
          list.forEach((element) => {
            if (element[0] && element[1]) {
              let latLng = null;
              if (mapType === "openStreetMap") {
                if (element[2] > "v2.3") {
                  latLng = new PruneCluster.Marker(element[1], element[0]);
                  latLng.data.name =
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;加载中......&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                } else {
                  let mypoint = coordtransform.wgs84togcj02(
                    element[1],
                    element[0]
                  );
                  latLng = new PruneCluster.Marker(mypoint[0], mypoint[1]);
                  latLng.data.name =
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;加载中......&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                }
              } else {
                if (element[2] > "v2.3") {
                  let mypoint = coordtransform.wgs84togcj02(
                    element[1],
                    element[0]
                  );
                  latLng = new PruneCluster.Marker(mypoint[0], mypoint[1]);
                  latLng.data.name =
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;加载中......&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                } else {
                  latLng = new PruneCluster.Marker(element[1], element[0]);
                  latLng.data.name =
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;加载中......&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
                }
              }
              latLng.data.did = element[3];
              this.markers.PrepareLeafletMarker = function (
                leafletMarker,
                data
              ) {
                leafletMarker.on("click", function (e) {
                  getMarkerInfo({
                    deviceId: data.did,
                  }).then((res) => {
                    try {
                      setTimeout(() => {
                        document.getElementsByClassName(
                          "leaflet-popup-content"
                        )[0].innerHTML = `${res.data.data.deviceSN}${res.data.data.deviceAddress
                            ? "<br/>" + res.data.data.deviceAddress
                            : ""
                          }${res.data.data.deviceName
                            ? "<br/>" + res.data.data.deviceName
                            : ""
                          }`;
                        document.getElementsByClassName(
                          "leaflet-popup-content-wrapper"
                        )[0].style.width = "180px";
                      },1000);
                    } catch(e) {
                      console.log(e);
                     }
                  });
                });
                if (leafletMarker.getPopup()) {
                  leafletMarker.setPopupContent(data.name);
                } else {
                  leafletMarker.bindPopup(data.name);
                }
              };
              this.markers.RegisterMarker(latLng);
              // let m = L.marker(latLng);
              // m.bindPopup(content);
              // this.markers.addLayer(m);
            }
          });
          this.map.addLayer(this.markers);
          // 监听地图的点击
          // this.map.addLayer(this.markers);
        }
      );
    },
    // 选择设备
    selectChange() {
      this.map.remove();
      this.initMap();
    },
  },
  beforeDestroy() {
    //页面销毁前清除所有图表数据
    this.list1 = [];
    this.markers = [];
    this.map.remove();
    //页面销毁前删除定时器
    clearInterval(this.DeviceTime);
    clearInterval(this.MapTime);
  },
};
</script>
<style scoped>
@import "./p.css";

.con {
  margin: 0 auto;
}

.leftcon {
  background-color: #566270;
  height: 5rem;
  border-radius: 5%;
  width: 100%;
  margin: 0.2rem 0;
  color: #60b0de;
}

.topcon {
  height: 1.8rem;
  width: 100%;
  background-color: #102f52;
  color: #60b0de;
}

.topcon p {
  color: #60b0de;
  font-size: 0.35rem;
  padding-top: 0.5rem;
  text-indent: 0.5rem;
}

.bottomcon {
  height: 4rem;
  width: 100%;
  background-color: #102f52;
  color: #3197de;
}

.bottomcon p {
  color: #60b0de;
  font-size: 0.35rem;
  padding-top: 0.5rem;
  text-indent: 0.5rem;
}

.cen {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 100;
}

.lefcen {
  width: 15%;
  height: 62vh;
  position: fixed;
  z-index: 999;
  float: left;
  margin-top: 0.2rem;
}

.rigcen {
  width: 15%;
  height: 95vh;
  position: fixed;
  z-index: 101;
  float: right;
  top: 86px;
  left: 79.2%;
}

.Map_Select {
  float: right;
  overflow: hidden;
  width: 100%;
}

#map {
  height: 100%;
  width: 100%;
}

.MapTime {
  position: fixed;
  top: 20vh;
  left: 40%;
  font-size: 20px;
  color: red;
  font-weight: bold;
  z-index: 999;
}
</style>
<style>
.my-label {
  color: red;
  font-size: 17px;
  font-weight: bolder;
}
</style>
